import styled from 'styled-components/macro';

const TextareaWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 50%;
  padding-left: 136px;
  padding-right: 100px;
`;

export default TextareaWrapper;
